import { SPACE } from '$gstyles';
import { Popover } from '@material-ui/core';
import styled from 'styled-components';

export const PopoverWrapper = styled(Popover)`
  &&.backdrop {
    background-color: rgba(0, 0, 0, 0.4);
  }

  .pop-container {
    padding: ${SPACE.SMALL};
  }

  button.left .MuiButton-label {
    justify-content: flex-start;
  }
`;
